import { FC } from 'react';

import { ColorConfig } from '@/contexts/AntdConfigProvider/theme';

import { icons, IconName } from './icons';

export interface IconProps {
  name: IconName;
  width?: number;
  height?: number;
  color?: ColorConfig;
  className?: string;
}

export const Icon: FC<IconProps> = ({ name, width = 24, height = 24, color, ...props }) => {
  const IconComponent = icons[name];

  return (
    <IconComponent
      {...props}
      aria-label={name}
      width={width}
      height={height}
      title={name}
      style={color ? { color: `var(--${color})` } : undefined}
    />
  );
};
